<div class="vtr-modal-wait modal-body">
	<h1 id="wait-title" class="title" role="heading">{{modalTitle}}</h1>
	<p id="wait-description" class="description" role="text">{{modalDescription}}</p>

	<div class="row line-separator">
		<div id="loading-div">
			<fa-icon id="loading-icon" [attr.aria-label]="'Loading Icon'" role="img" placement="auto" [spin]="true" [icon]="['fal', 'circle-notch']" container="body">
			</fa-icon>
		</div>
	</div>

	<div class="btn-modal-close">
		<vtr-ui-close-button
			linkId="hwscan-wait-modal-close-btn"
			(clickClose)="closeModal('cancel')">
		</vtr-ui-close-button>
	</div>
</div>
